module.exports = __webpack_public_path__ + "static/media/mars-stroke-v.50fe964d.svg";